import request from '@/utils/request'

const budgetApi = {
  // 获取BUSE
  getAllRegionList: () => {
    return request({
      url: '/trade-budget/bu/list',
      method: 'post'
    })
  },
  // 获取区域
  getOrgList: (params) => {
    return request({
      url: '/trade-budget/region/list',
      method: 'post',
      data: params
    })
  },
  // 获取-预算配置-table
  getPerfectThemeList: (params) => {
    return request({
      url: '/trade-budget/info/list',
      method: 'post',
      data: params
    })
  },
  // 获取--预算池名称
  getTableHeadConfig: (params) => {
    return request({
      url: '/trade-budget/type/list',
      method: 'post',
      data: params
    })
  },
  // 获取编辑状态
  // editorBudget: (params) => {
  //   return request({
  //     url: '/budget/stat',
  //     method: 'get',
  //     params
  //   })
  // },
  // 维护预算池-删除
  delBudget: (params) => {
    return request({
      url: '/trade-budget/type/delete',
      method: 'post',
      data: params
    })
  },
  // 维护预算池-确认
  confirm: (params) => {
    return request({
      url: '/trade-budget/type/update',
      method: 'post',
      data: params
    })
  },
  // 编辑预算--提交
  editorConfirm: (params) => {
    return request({
      url: '/trade-budget/info/update',
      method: 'post',
      data: params
    })
  },
  // 查询预算统计数据
  queryBudgetStatList: (params) => {
    return request({
      url: '/budget/stat',
      method: 'get',
      params
    })
  },
  // 预算列表
  getBudgetList: (params) => {
    return request({
      url: '/quota/trade/money-list',
      method: 'get',
      params
    })
  },
  // 获取area
  getAreaListByRegion: (params) => {
    return request({
      url: '/trade-budget/area/list',
      method: 'post',
      data: params
    })
  },
  // 预算列表数据详情
  budgetListDetail: (params) => {
    return request({
      url: '/quota/used-history',
      method: 'get',
      params
    })
  },

  // 导出预算列表数据详情
  getExportUrl: (params) => {
    return request({
      url: '/quota/used-history/export',
      method: 'get',
      params
    })
  }
}

export default budgetApi
